import navigationEffect from "../animations/navigationEffect";
import {motion} from "framer-motion";

export const Issue = () => {
    return (
        <motion.div {...navigationEffect} className="h-100 w-100 p-0 align-items-center justify-content-center d-flex position-absolute top-0 below-nav">
            <div className="text-center justify-content-center align-items-center">
                <h1>Май нещо липсва 😟</h1>
                <h3>Опитайте по-късно 🥺🔌</h3>
                <h4>Може би просто има проблем</h4>
            </div>
        </motion.div>
    );
};